import apiClient from '../api.js';

const resource = '/gestion'

const useGestionApi = {
    obtenerGestionesActivas(){
        return apiClient.get(`${resource}`);
    },
    // Listado completo de gestiones (todas, no solo las vigentes del año en
    // curso), ordenadas por `ord` desde el backend. Vive bajo `/academico`
    // porque es el endpoint nuevo con SQL versionado en el repo, a diferencia
    // de `obtenerGestionesActivas` (llama a una función almacenada legacy).
    listarGestiones(){
        return apiClient.get('/academico/gestiones');
    }
}
export default useGestionApi;